module.exports = __webpack_public_path__ + "img/redes-logo.2f5daf49.png";